import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TinvPharmacySaleService {
  tinvPharmacySale: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'tinv_pharmacy_sale/list/?';
  private AddRecord = webapi + 'tinv_pharmacy_sale/create';
  private EditRecord = webapi + 'tinv_pharmacy_sale/update';
  private GetRecord = webapi + 'tinv_pharmacy_sale/byid/';
  private DeleteRecord = webapi + 'tinv_pharmacy_sale/delete/';
  private OutStanding = webapi + 'tinv_pharmacy_sale/updateoutstanding';
  private DeliveryStatus = webapi + 'tinv_pharmacy_sale/isdelivery/';
  private SerachBills = webapi + 'tinv_pharmacy_sale/search/';
  private SerachunitBills = webapi + 'tinv_pharmacy_sale/searchunitwise?';
  private UpdateSponsor = webapi + 'tinv_sponsor_for_pharmacy/create';
  private ListRecordByUnitId = webapi + 'tinv_pharmacy_sale/listByUnitId/?';
  private SerachunitBillsDTO = webapi + 'tinv_pharmacy_sale/getPharmacyListByUnitId/';
  private closePrescriptionURL = webapi + 'tinv_pharmacy_sale/closePrescription';
  private checkPharmacyOutstanding = webapi + 'tinv_pharmacy_sale/getPatientOutstanding/?';
  private getPharmacylist = webapi + 'tinv_pharmacy_sale/getPatientPharmacySale/?';
  private getNursingPrescription = webapi + 'tnst_in_patient/getNursingItemByPatientId/?';
  private GettarriffById = webapi + 'mbill_tariff/byid/';
  private getPharmacycalculation = webapi + 'tinv_pharmacy_sale/getPharmacyBillCalaulation/?';
  private checkPharmacyRemainsByAdmisionId = webapi + 'tinv_pharmacy_sale/getPatientOutstandingByAdmisionId/?';
  private getPharmacyRemainsBillsByAdmisionId = webapi + 'tinv_pharmacy_sale/getPatientOutstandingListByAdmisionId/?';
  private getAllNursingData = webapi + 'tnst_in_patient/getAllNursingIndentRequsets';
  private ListRecordByPatientId = webapi + 'tinv_pharmacy_sale/getsaleshistory/?';
  private ListByPatientId = webapi + 'tinv_pharmacy_sale/bypatientid/';

  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordServiceByUnitId(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any): Promise<any> {
    return this.http.get(this.ListRecordByUnitId + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col + '&unitId=' + unitId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  onUpdateOutStandingAmount(model: any) {
    return this.http.put(this.OutStanding, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getUpdateBillDelivery(id: any) {
    return this.http.get(this.DeliveryStatus + id).toPromise().then(response => response.json()).catch(this.handleError);
  }

  getPharmacyBillListDependswithunitOnSearch(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.SerachunitBills, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getPharmacyBillListDependswithunitDTO(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.SerachunitBillsDTO, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getPharmacyBillListDependsOnSearch(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.SerachBills, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addSponsorForPharmacyService(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.UpdateSponsor, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getClosePrescription(model: any) {
    return this.http.put(this.closePrescriptionURL, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  checkPharmacyOutstandingPay(admissionId: any): Promise<any> {
    return this.http.get(this.checkPharmacyOutstanding + 'admissionId=' + admissionId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  // use by jay for billing
  getPharmacysalelist(adminsionId: any): Promise<any> {
    return this.http.get(this.getPharmacylist + 'adminsionId=' + adminsionId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getNursingItemRequest(patientId: any): Promise<any> {
    return this.http.get(this.getNursingPrescription + 'patientId=' + patientId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getTarriffObjectById(tariffId: any) {
    return this.http.get(this.GettarriffById + tariffId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getPharmacyCalCulatedData(adminsionId: any): Promise<any> {
    return this.http.get(this.getPharmacycalculation + 'adminsionId=' + adminsionId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  //use by abhi for ADT
  checkPharmacyOutstandingByAdmisionId(admisionId: any): Promise<boolean> {
    return this.http.get(this.checkPharmacyRemainsByAdmisionId + 'admisionId=' + admisionId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  //for merge ipd and pharmacy bill
  getPharmacyOutstandingBillByAdmisionId(admisionId: any): Promise<any> {
    return this.http.get(this.getPharmacyRemainsBillsByAdmisionId + 'admisionId=' + admisionId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    getAllNursingRequest(): Promise<any> {
        return this.http.get(this.getAllNursingData)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getshowMedicalHistoryByPatientId(currentPage: any, size: any, patientId: any): Promise<any> {
        return this.http.get(this.ListRecordByPatientId + 'page=' + currentPage + '&size=' + size + '&patientId='  + patientId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    getListByPatientId( patientId: any): Promise<any> {
        return this.http.get(this.ListByPatientId + patientId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/inventory/tinv-pharmacy-sale/tinv-pharmacy-sale.service.ts